/**
 * DEV-only staged trace for Gabi Golani Discover pipeline debugging.
 * Gate: import.meta.env.DEV && userId === GABI_ID
 */

export const GABI_ID = '42ca102c-dc05-4945-8b11-d07451d4f7c6';

export const isGabiDiscoverDebug = (userId?: string | null): boolean =>
  import.meta.env.DEV && userId === GABI_ID;

export type GabiRejectReason = {
  id: string;
  name: string;
  reason: string;
};

const MAX_REJECT_LOG = 20;

export function logGabiDiscoverStage(
  userId: string | undefined | null,
  stage: string,
  payload: Record<string, unknown>
): void {
  if (!isGabiDiscoverDebug(userId)) return;
  console.log(`[GABI_DISCOVER] ${stage}`, payload);
}

export function summarizeRejects(
  rejects: GabiRejectReason[],
  stage: string,
  userId: string | undefined | null
): void {
  if (!isGabiDiscoverDebug(userId) || rejects.length === 0) return;
  const shown = rejects.slice(0, MAX_REJECT_LOG);
  const extra = rejects.length - shown.length;
  console.log(`[GABI_DISCOVER] ${stage}_rejects`, {
    count: rejects.length,
    rejects: shown,
    ...(extra > 0 ? { truncated: extra } : {}),
  });
}
